function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var buttonVariants = ['primary', 'secondary', 'secondary-inverted', 'tertiary', 'success', 'critical', 'critical-secondary'];
export var applyToAllStates = props => _objectSpread(_objectSpread({}, props), {}, {
  _hover: props,
  _focusVisible: props,
  _active: props
});
export function getButtonVariants() {
  return {
    primary: {
      container: {
        backgroundColor: 'brand.main',
        color: 'neutral.white',
        _hover: {
          backgroundColor: 'brand.dark'
        },
        _active: {
          backgroundColor: 'brand.darkest'
        },
        _loading: {
          backgroundColor: 'brand.dark'
        },
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: '2px',
          transition: 'outline-color 0.2s'
        },
        '&[data-inverted="true"]': {
          _focusVisible: {
            outlineColor: 'focus.invert',
            outlineOffset: '2px',
            transition: 'outline-color 0.2s'
          }
        },
        _disabled: applyToAllStates({
          backgroundColor: 'neutral.light',
          color: 'neutral.white'
        })
      }
    },
    secondary: {
      container: {
        backgroundColor: 'transparent',
        color: 'brand.main',
        border: 'basic.brand',
        _hover: {
          backgroundColor: 'brand.lightest',
          color: 'brand.dark',
          borderColor: 'brand.dark'
        },
        _active: {
          backgroundColor: 'brand.lighter',
          color: 'brand.darkest',
          borderColor: 'brand.darkest'
        },
        _loading: {
          backgroundColor: 'brand.lightest',
          color: 'brand.dark',
          borderColor: 'brand.dark'
        },
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: '2px',
          transition: 'outline-color 0.2s'
        },
        _disabled: applyToAllStates({
          border: 'basic.light',
          backgroundColor: 'transparent',
          color: 'neutral.light'
        })
      }
    },
    'secondary-inverted': {
      container: {
        backgroundColor: 'transparent',
        color: 'neutral.white',
        border: 'basic.white',
        _hover: {
          backgroundColor: 'rgba(255, 255, 255, 0.15)'
        },
        _active: {
          backgroundColor: 'rgba(255, 255, 255, 0.35)'
        },
        _loading: {
          backgroundColor: 'rgba(255, 255, 255, 0.15)'
        },
        _focusVisible: {
          outlineColor: 'focus.invert',
          outlineOffset: '2px',
          transition: 'outline-color 0.2s'
        },
        _disabled: applyToAllStates({
          backgroundColor: 'transparent',
          color: 'neutral.white',
          opacity: 0.35
        })
      }
    },
    tertiary: {
      container: {
        backgroundColor: 'transparent',
        color: 'neutral.black',
        border: 'basic.light',
        _hover: {
          backgroundColor: 'neutral.lightest',
          color: 'neutral.black'
        },
        _active: {
          backgroundColor: 'neutral.light',
          color: 'neutral.black'
        },
        _loading: {
          backgroundColor: 'neutral.lightest'
        },
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: '2px',
          transition: 'outline-color 0.2s'
        },
        _disabled: applyToAllStates({
          backgroundColor: 'transparent',
          color: 'neutral.light'
        })
      }
    },
    success: {
      container: {
        backgroundColor: 'success.main',
        color: 'neutral.white',
        _hover: {
          backgroundColor: 'success.dark'
        },
        _active: {
          backgroundColor: 'success.darkest'
        },
        _loading: {
          backgroundColor: 'success.dark'
        },
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: '2px',
          transition: 'outline-color 0.2s'
        },
        _disabled: applyToAllStates({
          backgroundColor: 'neutral.light',
          color: 'neutral.white'
        })
      }
    },
    critical: {
      container: {
        backgroundColor: 'critical.main',
        color: 'neutral.white',
        _hover: {
          backgroundColor: 'critical.dark'
        },
        _active: {
          backgroundColor: 'critical.darkest'
        },
        _loading: {
          backgroundColor: 'critical.dark'
        },
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: '2px',
          transition: 'outline-color 0.2s'
        },
        _disabled: applyToAllStates({
          backgroundColor: 'neutral.light',
          color: 'neutral.white'
        })
      }
    },
    'critical-secondary': {
      container: {
        backgroundColor: 'transparent',
        color: 'critical.main',
        border: 'basic.critical',
        _hover: {
          backgroundColor: 'critical.lightest',
          color: 'critical.dark',
          borderColor: 'critical.dark'
        },
        _active: {
          backgroundColor: 'critical.lighter',
          color: 'critical.darkest',
          borderColor: 'critical.darkest'
        },
        _loading: {
          backgroundColor: 'critical.lightest',
          color: 'critical.dark',
          borderColor: 'critical.dark'
        },
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: '2px',
          transition: 'outline-color 0.2s'
        },
        _disabled: applyToAllStates({
          border: 'basic.light',
          backgroundColor: 'transparent',
          color: 'neutral.light'
        })
      }
    }
  };
}
//# sourceMappingURL=button.theme.utils.js.map